module.exports = __webpack_public_path__ + "media/3x/C-1caec71e.png";